<div class="wrapper">
    <div id="map"></div>
    <div class="content">
        <ul class="list-group list-group-icons-meta">
            <li class="list-group-item list-group-item-action">
                <div class="media">
                    <div class="d-flex mr-3">
                       Trip ID
                    </div>
                    <div class="media-body text-right">
                        <h6 class="tx-inverse">{{tripID}}</h6>
                    </div>
                </div>
            </li>
            <li class="list-group-item list-group-item-action">
                <div class="media">
                    <div class="d-flex mr-3">
                       Device ID
                    </div>
                    <div class="media-body text-right">
                        <h6 class="tx-inverse">{{deviceID}}</h6>
                    </div>
                </div>
            </li>
            <li class="list-group-item list-group-item-action">
                <div class="media">
                    <div class="d-flex mr-3">
                    Truck No
                    </div>
                    <div class="media-body text-right">
                        <h6 class="tx-inverse">{{trip?.truckNo}}</h6>
                    </div>
                </div>
            </li>
            <li class="list-group-item list-group-item-action">
                <div class="media">
                    <div class="d-flex mr-3">
                    Permit No
                    </div>
                    <div class="media-body text-right">
                        <h6 class="tx-inverse">{{trip?.permitNo}}</h6>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>